import { PageLoading } from 'module/ui/components/atoms/loading';
import React, { Suspense } from 'react';
import { StyleSheetManager } from 'styled-components';

// Dynamic import of the federated component
const SignalAgentsApp = React.lazy(() =>
  import('agentBuilder/SignalAgentsApp').then((module) => ({
    default: module.SignalAgentsApp,
  })),
);

export const SignalAgentsRemote: React.FC = () => {
  return (
    <Suspense fallback={<PageLoading />}>
      <StyleSheetManager target={document.head}>
        <SignalAgentsApp />
      </StyleSheetManager>
    </Suspense>
  );
};
